import clsx from 'clsx';
import { Trans, useTranslation } from 'react-i18next';

import globalStyle from '@vestico/shared/src/layouts/utils.module.css';

import { Popover, PopoverPosition } from './Popover';
import style from './privacy.module.css';

export const VESTICO_URL = 'https://vestico.co/';
export const VESTICO_PRIVACY_POLICY_URL = 'https://vestico.co/privacy';
export const VESTICO_TERMS_OF_SERVICE_URL = 'https://vestico.co/terms';

export interface PrivacyProps {
  popoverBackground: string;
  position: PopoverPosition;
  buttonColor?: string;
  customPrivacyURL?: string;
}

export const Privacy = ({ popoverBackground, position, buttonColor, customPrivacyURL }: PrivacyProps) => {
  const { t } = useTranslation('shared');

  const privacyOverlay = (
    <div className={clsx(globalStyle.textSmall, style.textSmall)}>
      <Trans t={t} i18nKey="LOC_PRIVACY_INFO_TEXT">
        A service by {/* skipcq JS-0422 */}
        {/* eslint-disable-next-line react/jsx-no-target-blank */}
        <a href={VESTICO_URL} target="_blank" rel="noopener" className={clsx(style.privacyLink)}>
          vestico
        </a>
        ,
        <br />
        find the privacy notice {/* skipcq JS-0422 */}
        {/* eslint-disable-next-line react/jsx-no-target-blank */}
        <a href={customPrivacyURL ?? VESTICO_PRIVACY_POLICY_URL} target="_blank" rel="noopener" className={clsx(style.privacyLink)}>
          here
        </a>
        .
      </Trans>
    </div>
  );

  return (
    <Popover
      activator={t('LOC_PRIVACY_BUTTON')}
      position={position}
      backgroundColor={popoverBackground}
      contentWidth="202px"
      buttonColor={buttonColor}
    >
      {privacyOverlay}
    </Popover>
  );
};
